import { useMemo } from 'react';
import { deviceTypes, ORIGIN_SOURCE } from '@nykaa/cart-shared/constants';
import { EDD_EXPERIEMENT_HEADER } from '@nykaa/cart-shared/store/constants';
import { useIsConvenienceFeeEnabled } from 'hooks';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { State } from 'store/types';

interface item {
  productId: string;
  qty: number;
}

export interface CartDataParams {
  deviceType: string;
  originSource: string;
  domain: string;
  catalog_tag_filter: string;
  headers: Record<string, boolean>;
  items?: item[];
  productIds?: string[];
}

const getOriginSource = (pathName: string) => {
  switch (true) {
    case pathName.includes('/c/'):
      return ORIGIN_SOURCE.CATEGORY_LISTING;
    case pathName.includes('/offer-products/'):
      return ORIGIN_SOURCE.OFFER_LISTING_PAGE;
    case pathName.includes('/search/result/'):
      return ORIGIN_SOURCE.SEARCH_LISTING;
    default:
      return ORIGIN_SOURCE.SEARCH_LISTING;
  }
};
export const useGetBaseDataCartApi = () => {
  const { pathname } = useLocation();
  const isConvenienceFeeEnabled = useIsConvenienceFeeEnabled();
  const cartEddWidget = useSelector(
    (state: State) => state.remoteConfig?.switches?.cartEddWidget
  );
  const apiParams = useMemo(
    (): CartDataParams => ({
      deviceType: deviceTypes.MSITE,
      originSource: getOriginSource(pathname),
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
      headers: { [EDD_EXPERIEMENT_HEADER]: !!cartEddWidget },
    }),
    [pathname, cartEddWidget]
  );
  return { apiParams, isConvenienceFeeEnabled };
};
